/**
 * Check whether a given string looks like a valid email address.
 * (Ported directly from mp.utility, no guarantees about correctness!)
 * @param {string} str - string to check
 * @returns {boolean} whether string passes email-format test
 */
const EMAIL_FILTER = /^[+a-zA-Z0-9_'.-]+@([a-zA-Z0-9-]+\.)+[a-zA-Z0-9]{2,}$/;
export function isValidEmail(str) {
  return EMAIL_FILTER.test(str);
}

/**
 * Check whether a given string looks like a valid domain (very basic for now)
 * @param {string} str - string to check
 * @returns {boolean} whether string passes domain test
 */
const DOMAIN_FILTER = /^[^ ]+\.[^ ]+$/;
export function isValidDomain(str) {
  return DOMAIN_FILTER.test(str.trim());
}

/**
 * Check whether a given string includes another string while ignoring case
 * @param {string} str - string to check
 * @param {string} searchString - string to match on
 * @returns {boolean} whether str contains searchString
 */
export function caseInsensitiveIncludes(str, searchString) {
  return !!str.toLowerCase().includes(searchString.toLowerCase());
}

/**
 * Remove all non-alpha/unicode characters
 * @param {string} str - string to sanitize
 * @returns {string} the sanitized string
 */
export function alphaUnicodeOnly(str) {
  return str.match(/[a-z0-9]|[^\u0000-\u007F]/gi).join(``);
}
